import { Reveal, Overline } from "./primitives";
import { COMPANY } from "./data";
import { ShieldCheck } from "lucide-react";

export const Company = () => {
  return (
    <section
      id="company"
      data-testid="company-section"
      className="relative bg-white py-24 sm:py-32"
    >
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <Reveal>
          <Overline>The Company</Overline>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-heading text-4xl font-bold leading-[1.08] tracking-tight text-slate-900 sm:text-[42px]">
            About {COMPANY.name}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-lg leading-relaxed text-slate-600">
            {COMPANY.name} is a technology startup focused on developing digital
            solutions for agricultural water infrastructure and pipeline
            planning.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            Our mission is to make engineering-based pipeline design simple,
            accessible and practical for farmers, pipe dealers and technicians
            across India.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-10 border-l-2 border-[#5aa72f] pl-6">
            <p className="font-heading text-xl font-semibold tracking-tight text-slate-900">
              Engineering-based pipeline design, made accessible.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-8" data-testid="dpiit-credibility">
            <span className="inline-flex flex-wrap items-center gap-x-2.5 gap-y-1 rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-medium text-slate-700">
              <ShieldCheck className="h-4 w-4 shrink-0 text-[#1a6fc4]" />
              DPIIT Recognised Startup
              <span className="text-slate-300">|</span>
              <span className="font-mono text-[13px] text-slate-500">
                Recognition No. DIPP267967
              </span>
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
